import { Directive } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';

@Directive({
  selector: '[webAppServicesGermanNgbDateValidator]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: GermanNgbDateValidatorDirective,
      multi: true,
    },
  ],
  standalone: true,
})
export class GermanNgbDateValidatorDirective implements Validator {
  public validate(control: AbstractControl): ValidationErrors | null {
    if (typeof control.value !== 'object' && !this.#isValidIsoDateString(control.value)) {
      return {
        noValidGermanDate: true,
      };
    }
    return null;
  }

  #isValidIsoDateString(dateString: string) {
    const isoPattern = dateString && typeof dateString === 'string' && RegExp(/\d{4}-\d{1,2}-\d{1,2}.*/).exec(dateString);
    return isoPattern && !isNaN(Date.parse(dateString));
  }
}
